/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangePasswordRequestBody
 */
export interface ChangePasswordRequestBody {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequestBody
     */
    currentPassword: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequestBody
     */
    newPassword: string;
}

/**
 * Check if a given object implements the ChangePasswordRequestBody interface.
 */
export function instanceOfChangePasswordRequestBody(value: object): value is ChangePasswordRequestBody {
    if (!('currentPassword' in value) || value['currentPassword'] === undefined) return false;
    if (!('newPassword' in value) || value['newPassword'] === undefined) return false;
    return true;
}

export function ChangePasswordRequestBodyFromJSON(json: any): ChangePasswordRequestBody {
    return ChangePasswordRequestBodyFromJSONTyped(json, false);
}

export function ChangePasswordRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangePasswordRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPassword': json['currentPassword'],
        'newPassword': json['newPassword'],
    };
}

export function ChangePasswordRequestBodyToJSON(json: any): ChangePasswordRequestBody {
    return ChangePasswordRequestBodyToJSONTyped(json, false);
}

export function ChangePasswordRequestBodyToJSONTyped(value?: ChangePasswordRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPassword': value['currentPassword'],
        'newPassword': value['newPassword'],
    };
}

